import React, { useState, useEffect } from "react";
import "./styles/sign-in-up.css";
import { Result, Button, Popconfirm } from "antd";
import "./styles/sign-in-up.css";
import { useNavigate } from "react-router-dom";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import Axios from "../api/Axios";
import MloginIcon from "../assets/icons/ms-symbollockup_mssymbol_19.png";
import { DoubleLeftOutlined } from "@ant-design/icons";
const MicrosoftLoginFailed = () => {
  const { instance, accounts } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const [errMessage, setErrMessage] = useState("");
  const history = useNavigate();
  const logoutMS = () => {
    instance.logoutRedirect();
  };
  const MSLogin = async (token) => {
    const payload = {
      microsoft_access_token: token,
    };
    try {
      await Axios.post("/login/", payload);
      //console.log(res.data);
    } catch (err) {
      //console.log(err?.response?.data?.detail);
      setErrMessage(err?.response?.data?.detail);
    }
  };
  useEffect(() => {
    const fetchData = async () => {
      if (isAuthenticated && accounts.length > 0) {
        const accessTokenRequest = {
          // scopes: ["User.ReadBasic.All"],
          scopes: ["User.Read"],
          account: accounts[0], // Use the first authenticated account
        };

        try {
          const response = await instance.acquireTokenSilent(
            accessTokenRequest
          );
          MSLogin(response.accessToken);
          //console.log("Access Token:", response.accessToken);
        } catch (error) {
          console.error("Access Token:", error);
        }
      } else {
        history("/");
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, accounts, instance]);
  return (
    <Result
      status="404"
      title={<span style={{ fontSize: "20px" }}>Account doesn't exist</span>}
      subTitle={
        <p style={{ fontSize: "15px", fontWeight: "500" }}>
          <span style={{ fontSize: "15.5px", fontWeight: "700" }}>
            {errMessage}
          </span>
          <div>
            If you want to use other Microsoft account then please logout below
            and try again.
          </div>
        </p>
      }
      extra={[
        <Button
          type="default"
          onClick={() => {
            history("/");
          }}
          key="home"
          style={{ verticalAlign: "middle" }}
        >
          <DoubleLeftOutlined />
          Back to Login
        </Button>,
        <Popconfirm
          title="Confirm Sign Out"
          description="Logout from current Microsoft account"
          okText="Yes"
          cancelText="No"
          onConfirm={logoutMS}
        >
          <Button type="default" style={{ verticalAlign: "middle" }}>
            <img
              src={MloginIcon}
              alt=""
              style={{
                marginRight: "7.5px",
                verticalAlign: "middle",
                height: "17px",
              }}
            />
            Sign Out
          </Button>
        </Popconfirm>,
      ]}
    />
  );
};

export default MicrosoftLoginFailed;
